
import Vue from 'vue'
import SignInUpCommon from '@/components/user/SignInUpCommon.vue'

export default Vue.extend({
  name: 'ThankYouForSubscribing',
  components: {
    SignInUpCommon,
  },
  data: () => ({
    thankYouMessage: '',
  }),

  mounted() {
    this.$api.get('/contents/static/newsletterThankYou')
      .then((result) => {
        this.thankYouMessage = result.data.message
      })
  }
})
